export const getVisibilityButton = function (button, row, rowIndex, rows) {
  if (button.visibilityExpression) {
    const visibility = new Function(['row', 'rowIndex', 'rows'], `return ${button.visibilityExpression}`)
    return visibility(row, rowIndex, rows)
  }

  return true
}